import React, { Fragment, useState } from 'react'
import OrgListView from '../../../components/application/create/org/OrgListView'
import AppURL from '../../../constants/AppURL';
import useFetchData from '../../../helpers/useFetch';

const OrganizationSetupCreateListView = () => {
    const [onURL, setOnURL] = useState(AppURL.ApplicationURL + 'app/organizaion/structure/list/view/');
    const { data, loading, error, refetch } = useFetchData(onURL);

    const handleFormSuccess = ():void => {
        refetch(); 
    };
   
  return (
    <Fragment>
        <OrgListView data={data} error={error} handleFormSuccess={handleFormSuccess} loading={loading} />
    </Fragment>
  )
}

export default OrganizationSetupCreateListView